module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-minus-abb5e0e0.svg";